/* eslint-disable */
export default {
  title: 'Alue',
  NAOnlyMessage: 'Anna suuntanumerosi. Sitä käytetään paikallispuheluissa.',
  MultiWithNAMessage:
    'Anna alueesi maakoodi ja suuntanumero. Tätä käytetään paikallispuheluihin sekä puhelinnumeron muotoiluun.',
  MultiWithoutNAMessage:
    'Valitse maa, jossa oleskelet. Tätä käytetään paikallispuheluihin sekä puhelinnumeron muotoiluun.',
  country: 'Maa',
  areaCode: 'Suuntanumero',
  areaCodePlaceholder: 'Anna suuntanumero',
} as const;

// @key: @#@"title"@#@ @source: @#@"Region"@#@
// @key: @#@"NAOnlyMessage"@#@ @source: @#@"Please set your area code. This will be used for local dialing."@#@
// @key: @#@"MultiWithNAMessage"@#@ @source: @#@"Please set the country and area code for your region. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"MultiWithoutNAMessage"@#@ @source: @#@"Please select the country you locate in. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"country"@#@ @source: @#@"Country"@#@
// @key: @#@"areaCode"@#@ @source: @#@"Area Code"@#@
// @key: @#@"areaCodePlaceholder"@#@ @source: @#@"Enter Area Code"@#@
